export const CAT = "choose_treatment_care_plus";

export const GRADIENT = "linear-gradient(90deg, rgb(245,146,0) 0%, rgb(255,187,41) 100%)";
export const TEXT_GRADIENT = "linear-gradient(189.45deg, #ffb909 0.80%, #e17200 94.83%)";
export const HERO_GRADIENT = "linear-gradient(180deg, #F59200 21.69%, #FFF 100%), #D9D9D9";

// Brands whose product image is a pen: the treatment hero shows it full width.
export const PEN_HERO_BRANDS = ["wegovy", "mounjaro", "saxenda", "nevolat"];
